import { Grid } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { appNote, buttonLabels, ViewTextLabels } from "./constants";
import DisplayContent from "./display-content.component";
import StepInputControl from "./step-input-control/step-input-control.component";
import { Link } from "react-router-dom";
import ButtonComponent from "./button/button.component";
import { AppRoutes } from "../routes/route.path";
import { AuthService } from "../../services/AuthService";
import { ArrowBackIcon, IncoreectIcon } from "../../icon";
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';

interface Props {
    StepLength: number;
    NumOfSteps: number;
    IsNumberInput: boolean;
    HandleOnChangeStepValue: (otp: any) => void;
    Value: string;
    ErrorMessage: string;
    ResendOtp: (e: any) => void;
    VerifyOtp: (e: any) => void;
    IsValid: boolean;
    ResendLabel: string;
    Title: string;
    SetWidth?: string;
    ShowResendTimer?: boolean;
    ResendTime: 15 | 30 | 45 | 60;
    IsLoading?: boolean;
    ButtonLabel?: string;
    ExceedCount?: boolean;
    IsSignUpBtn?: boolean;
    WrongAttemptsDisplayMsg?: string;
    WrongAttemptsBtnLabel?: string;
    WrongAttemptsBtnPath?: string;
    OtpTextFieldColor?: string;
    IsUnAuthScreen?: boolean;
    IsBackTologin?: boolean;
}

const TwoFactorAuthenticationForm = (props: Props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const timer = useRef<NodeJS.Timeout>(null)
    const [timerClock, setTimerClock] = useState<number>(props.ResendTime)

    useEffect(() => {
        setupTimer()
        return () => {
            clearTimer()
        }
    }, [])


    useEffect(() => {
        if (props.ShowResendTimer) {
            setTimerClock(isNaN(timerClock) ? props.ResendTime : timerClock)
            setupTimer()
        }
        else {
            clearTimer();
        }
    }, [props.ShowResendTimer])

    const clearTimer = () => {
        if (timer.current) {
            clearInterval(timer.current);
            setTimerClock(NaN)
        }
    }

    const setupTimer = () => {
        if (timer) {
            clearInterval(timer.current);
        }
        timer.current = setInterval(() => {
            setTimerClock((previousProps) => {
                const NewTimerClock = previousProps - 1
                if (!NewTimerClock) {
                    clearInterval(timer.current)
                }
                return NewTimerClock
            })
        }, 1000)
    }

    return (
        <>
            {props.IsValid ?
                <div className={`${!props.IsUnAuthScreen ? `b-around-primary-dark-1 br-2` : `d-flex flex-direction`} p-2`}>
                    <div className={`h5-regular mx-auto color-twoFa-label`}> {props.Title} </div>
                    <form onSubmit={props.VerifyOtp}>
                        <Grid container className={"mt-1"}>
                            <Grid item md={12} sm={12} xs={12} lg={12} className={`${props.IsUnAuthScreen && 't-align-center'}`}>
                                <StepInputControl stepLength={props.StepLength} numOfSteps={props.NumOfSteps} isNumberInput={props.IsNumberInput}
                                    handleOnChangeStepValue={(otp) => props.HandleOnChangeStepValue(otp)} setWidth={props.SetWidth} disabled={props.ExceedCount} OtpTextFieldColor={props.OtpTextFieldColor} />
                            </Grid>
                            <Grid item xs={9} sm={9} md={9} lg={9} xl={9} className={"mx-auto"}>
                                <ButtonComponent
                                    Variant={"primary-btn"}
                                    Loading={props.IsLoading}
                                    ButtonLabel={props.ButtonLabel ? props.ButtonLabel : "Verify OTP"}
                                    Type="submit"
                                    ClassName={`c-pointer w-fill justify-center primary-btn w-space ${IsMobileDevice ? "h2" : "h4-regular"} ${((props.Value.length < props.NumOfSteps) && !props.ExceedCount) && "disabled disabled-btn"} d-block`}
                                    buttonProps={{
                                        tabIndex: 5,
                                        "data-arrow-index": props.NumOfSteps + 2,
                                        "data-up-arrow-index": props.NumOfSteps + 1,
                                        "data-down-arrow-index": props.NumOfSteps + 2,
                                        "data-left-arrow-index": props.NumOfSteps + 2,
                                        "data-right-arrow-index": props.NumOfSteps + 2
                                    }}></ButtonComponent>
                            </Grid>
                            <Grid item md={12} sm={12} xs={12} className="d-flex justify-center mb-1">
                                {!!props.ErrorMessage && <span className={`color-primary-danger h5-regular t-align-center ${IsMobileDevice && "h5-regular"}`}> {props.ErrorMessage === 'Invalid OTP. Please try again' ? 'Invalid OTP. Please try again or click Resend OTP' : props.ErrorMessage} </span>}
                            </Grid>
                            <Grid item md={12} sm={12} xs={12} className={`w-space ${props.IsUnAuthScreen && 't-align-center'} mb-1`}>
                                {!props.ExceedCount && <span className={"twofa-didnot-recive-label color-twoFa-label"}>
                                    {appNote.DID_NOT_RECEIVE}
                                    {
                                        props.ShowResendTimer && timerClock ?
                                            <span>
                                                {props.ResendLabel + " in "}
                                                <span>{timerClock} {ViewTextLabels.SECONDS}</span>
                                            </span>
                                            :
                                            <Link tabIndex={6}
                                                to=""
                                                data-arrow-index={props.NumOfSteps + 1}
                                                data-up-arrow-index={1}
                                                data-down-arrow-index={props.NumOfSteps + 2}
                                                data-left-arrow-index={props.NumOfSteps + 1}
                                                data-right-arrow-index={props.NumOfSteps + 1} className={`h5-regular color-primary-light c-pointer`} onClick={props.ResendOtp}> {props.ResendLabel}
                                            </Link>}

                                </span>}
                            </Grid>
                            {props.IsBackTologin &&
                                <Grid item md={12} sm={12} xs={12} className={`my-auto mx-auto d-flex justify-center align-center`}>
                                    <span >
                                        <Link className="my-auto w-6"
                                            // tabIndex={7}
                                            // data-arrow-index={7}
                                            // data-up-arrow-index={7}
                                            // data-down-arrow-index={1}
                                            // data-left-arrow-index={7}
                                            // data-right-arrow-index={7}
                                            to={AppRoutes.SIGN_IN}
                                            onClick={() => {
                                                localStorage.clear();
                                                sessionStorage.clear();
                                            }}>
                                            <span className="d-flex align-center">
                                                <ArrowBackIcon className={"c-pointer float-left w-2"}
                                                />
                                                <span className="h5-regular ml-1 color-back-to-login">{buttonLabels.BACK_TO_LOGIN}</span>
                                            </span>
                                        </Link>
                                    </span>
                                </Grid>
                            }
                        </Grid>
                    </form>

                </div>
                :
                <DisplayContent
                    btnClass={`c-pointer d-flex justify-center primary-btn ${props.IsUnAuthScreen && 't-align-center'} ${IsMobileDevice ? "h2" : "h4-regular w-p-60 mx-auto"}`}
                    displayMsgClass={'h1-medium color-login-headers'}
                    displayIcon={IncoreectIcon}
                    displayMsg={props.WrongAttemptsDisplayMsg}
                    btnLabel={buttonLabels.BACK_TO_LOGIN}
                    btnPath={AppRoutes.SIGN_IN}
                    IsMobileDevice={IsMobileDevice}
                    displayMsgSubContent={"Please login or try again after some time "}
                    displayMsgSubContentClass={"h5-regular"}
                />
            }
        </>
    )
}

export default TwoFactorAuthenticationForm;